import SwitchButton from "@pathwright/ui/src/components/button/SwitchButton"
import { useScreensizeContext } from "@pathwright/ui/src/components/ui/Screensize"
import PropTypes from "prop-types"
import styled from "styled-components"
import useCommunityAreas from "./area/useCommunityAreas"

const StyledNav = styled.div`
  display: flex;
  justify-content: center;
  /* margin-bottom: 30px; */
  width: 100%;
  position: sticky;
  /* top: 1em; */
  /* height: 50px; */
  align-items: center;
  z-index: 1001;
  padding-top: 10px;
  padding-right: 10px;
  padding-left: 10px;
`

const StyledControls = styled.div`
  display: flex;
  talign-items: center;
  justify-content: flex-end;
  flex-grow: 1;
`

const CommunityNav = () => {
  const { areas, selectArea, renderControls, selectedAreaIndex } =
    useCommunityAreas()

  const screensize = useScreensizeContext()
  const iconMode = screensize === "sm" || screensize === "md"

  // Somehow rendering controls before the early return avoids a
  // glitch in the order in which hooks are called.
  const controls = renderControls()

  // don't show nav controls until all areas are ready
  if (
    areas.find((area) => !area.canView) ||
    areas.filter((area) => area.canView).length <= 1
  )
    return null

  return (
    <StyledNav>
      <SwitchButton
        inverted={true}
        options={areas}
        onChange={(index) => selectArea(areas[index].id)}
        activeIndex={selectedAreaIndex}
        iconMode={iconMode}
      />
      {/* <StyledControls>{controls}</StyledControls> */}
    </StyledNav>
  )
}

CommunityNav.displayName = "CommunityNav"

CommunityNav.propTypes = {
  onSelectCommunityArea: PropTypes.func,
  communityArea: PropTypes.string,
  inverted: PropTypes.bool
}

export default CommunityNav
